module.exports = __webpack_public_path__ + "static/img/detailsImg.9c98465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fiveth/detailsImg.png
// module id = jAsM
// module chunks = 1